import { Effect } from "../../../entities/Effect.js";

export function spawnDamageNumber(scene, x, y, damage) {
  const labelY = y - 28;
  const offsetX = (Math.random() - 0.5) * 20;
  const txt = scene.add.text(x + offsetX, labelY, String(damage), {
    fontFamily: "monospace",
    fontSize: "14px",
    fontStyle: "bold",
    color: "#ffffff",
    stroke: "#000000",
    strokeThickness: 3,
  }).setOrigin(0.5, 1).setDepth(4000 + labelY);

  scene.tweens.add({
    targets: txt,
    y: labelY - 34,
    alpha: 0,
    duration: 1200,
    ease: "Power1",
    onComplete: () => txt.destroy(),
  });
}

export function spawnPlayerDamageTaken(scene, x, y, damage) {
  const amount = Number(damage);
  if (!Number.isFinite(amount) || amount <= 0) return;
  const labelY = y - 44;
  const offsetX = (Math.random() - 0.5) * 20;
  const txt = scene.add.text(x + offsetX, labelY, `-${Math.round(amount)}`, {
    fontFamily: "monospace",
    fontSize: "14px",
    fontStyle: "bold",
    color: "#ff4d4d",
    stroke: "#000000",
    strokeThickness: 3,
  }).setOrigin(0.5, 1).setDepth(4000 + labelY);

  scene.tweens.add({
    targets: txt,
    y: labelY - 36,
    alpha: 0,
    duration: 1400,
    ease: "Power1",
    onComplete: () => txt.destroy(),
  });
}

export function spawnProjectileImpactEffect(scene, spriteConfig, centerX, centerY) {
  if (!Number.isFinite(centerX) || !Number.isFinite(centerY)) return;

  if (spriteConfig?.impactEffect) {
    const ie = spriteConfig.impactEffect;
    if (scene.textures.exists(ie.atlas)) {
      const effect = new Effect(scene, centerX, centerY, ie.atlas, ie.anim);
      scene.effects.push(effect);
    }
  }

  if (spriteConfig?.atlas === "food") {
    const effect = new Effect(scene, centerX, centerY, "explosion_1", "food_splat");
    effect.sprite.setScale(0.15);
    scene.effects.push(effect);
  }
}
